var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',[_vm._t("head"),_vm._t("body",null,{"displayData":_vm.displayData})],2)}
var staticRenderFns = []

export { render, staticRenderFns }